import { render, staticRenderFns } from "./ImprintPage.de.vue?vue&type=template&id=73309725"
import script from "./ImprintPage.de.vue?vue&type=script&lang=js"
export * from "./ImprintPage.de.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports